/**
 * @name hasRTLContext
 * @deprecated will be remove in 7.0.0 in favor of DirectionService
 * @description Checks if the given element is within an element that has the [dir="rtl"] attribute
 *
 * @example
 * import { hasRTLContext } from '@workbench/core';
 *
 * hasRTLContext(element); // true
 */
export function hasRTLContext(element: HTMLElement): boolean {
  return Boolean(element.closest('[dir="rtl"]'));
}
